import {DropdownOptionProps} from '../models/DropdownProps';
import {t} from 'i18next';

export const DROPDOWN_OPTION = 'DROPDOWN_OPTION_';
export const TYPE_ALL = 'all';
export const SELECT_PREFIX = 'SELECT_';
export const SELECT_OPTION = 'SELECT_OPTION';
export const SELECT_TYPE = 'SELECT_TYPE';
export const SELECT_LOCALE = 'SELECT_LOCALE';
export const SELECT_COUNTRY = 'SELECT_COUNTRY';
export const SELECT_LANGUAGE = 'SELECT_LANGUAGE';

export const getDropdownOptionPropsFromEntities = (dropdownOptionProps: DropdownOptionProps[]): DropdownOptionProps[] => {
    return getDropdownOptionProps(dropdownOptionProps.map(object =>
        ({
            name: getFormattedDropDownOptionPropsEntity(object.name),
            value: object.value
        } as DropdownOptionProps)), SELECT_OPTION, DROPDOWN_OPTION);
};

export const getDropdownOptionProps = (dropdownOptionProps: DropdownOptionProps[], fallbackName: string = SELECT_OPTION, namePrefix?: string): DropdownOptionProps[] => {
    return dropdownOptionProps
        .map(option => {
            return {
                name: getLocalizedDropdownOptionProps(option.name, fallbackName, namePrefix),
                value: option.value
            }
        });
};

export const getFilteredDropdownOptionProps = (dropdownOptionProps: DropdownOptionProps[], dropdownOptionPropsScope: string[], fallbackName: string = SELECT_OPTION, namePrefix?: string): DropdownOptionProps[] => {
    let options: DropdownOptionProps[] = [];
    dropdownOptionProps
        .filter(type => (dropdownOptionPropsScope.includes(type.name))
            && (!dropdownOptionPropsScope.includes(SELECT_TYPE)))
        .map(option => {
            options.push({
                name: getLocalizedDropdownOptionProps(option.name, fallbackName, namePrefix),
                value: option.value
            });
        });

    return Array.from(new Set(options));
};

export const getEmptyDropdownOptionProps = (option: string = SELECT_OPTION, fallbackOption: string = SELECT_OPTION, prefix?: string): DropdownOptionProps => {
    return {
        name: getLocalizedDropdownOptionProps(option, fallbackOption, prefix),
        value: ''
    }
};

export const getLocalizedDropdownOptionProps = (option?: string, fallbackOption: string = SELECT_OPTION, prefix?: string): string => {
    let effectivePrefix: string = (prefix && (DROPDOWN_OPTION === prefix)) ? prefix : '';
    let effectiveOption: string = option ?? fallbackOption;
    if (!(effectiveOption.toUpperCase()).startsWith(SELECT_PREFIX)) {
        if ((effectiveOption.toUpperCase()).startsWith(DROPDOWN_OPTION)) {
            return t(effectiveOption.toUpperCase());
        }

        return effectiveOption;
    }

    return t((effectivePrefix.toUpperCase()).concat(effectiveOption.toUpperCase())).toString();
};
export const getFormattedDropDownOptionPropsEntity = (object: string): string => {
    return (!object.toUpperCase().startsWith(SELECT_PREFIX)) ? DROPDOWN_OPTION.concat(object.toUpperCase()) : object.toUpperCase();
};
